module.exports = __webpack_public_path__ + "static/media/br-rr.449ebe6a.svg";